module.exports = __webpack_public_path__ + "static/media/stage1New.dc49682f.png";